<template>
    <div>
        <v-container fluid grid-list-xl pt-0 px-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="showModule()"
                                tooltip="Add Module"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetModules(true)"
                            ></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <v-container fluid grid-list-xl class="pa-0">
                        <v-layout xs12 row wrap :mt-2="$bp.smAndUp">
                            <v-flex v-for="(mod, index) in modules" :key="index" py-2 :class="[!$bp.smallScreen ? 'hoverable' : '', index != modules.length - 1 ? 'border-bottom-1' : '']">
                                <v-layout row wrap :class="$bp.smAndUp ? 'pa-2' : ''">
                                    <v-flex xs12 sm3>
                                        <span @click="showModule(mod)" class="clickable underline-hover"><b>{{ mod.module | start_case }}</b></span>
                                    </v-flex>
                                    <v-flex xs12 sm9 pa-0>
                                        <div :class="$bp.xsOnly ? 'pb-1' : ''">
                                            <v-btn
                                                @click="showPermission(mod)"
                                                class="my-0 text-center"
                                                round
                                                outline
                                                color="green"
                                                icon
                                            >
                                                <v-icon>add</v-icon>
                                            </v-btn>
                                            <v-btn
                                                @click="showPermission(mod, permission)"
                                                v-for="(permission, index) in mod.permission_functions" :key="index"
                                                class="my-1"
                                                style="min-width:75px; flex-direction: column; min-height: 36px; height: auto;"
                                                round
                                                outline
                                            >
                                                <span style="white-space: normal;">
                                                    {{ permission.permission | start_case }}
                                                </span>
                                            </v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>

            <bc-dialog :value="permission_module_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ current_module ? $t('lang.editModule') : $t('lang.addModule')}}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeModuleDialog"
                            :dialog-status="permission_module_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="permission_module" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
											v-focus="permission_module_dialog"
											v-model="permission_module.module"
											:label="`${$t('lang.module')} *`"
											:counter="showCounter(permission_module.module, 'permission_module.module')"
											:rules="ifValid('permission_module.module')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currModuleField('module_id')" color="error" @mouseup.left="$refs.delete_module.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeModuleDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyModule(currModuleField('module_id') ? 'patch' : 'post', currModuleField('module_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>

            <bc-dialog :value="permission_function_dialog">
                <v-card>
                    <v-card-title class="pb-1">
                        <span class="headline">{{ currFunctionField('function_id') ? $t('lang.editPermission') : $t('lang.addPermission') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="permission_function_dialog"
                            :dialog-status="permission_function_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="permission_function">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex>
                                        <span class="fs-16">{{ $t('lang.module') }}</span>
                                        <h3>{{ currModuleField('module') | start_case }}</h3>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
											v-focus="permission_function_dialog"
											v-model="permission_function.permission"
											:label="`${$t('lang.permission')} *`"
											:counter="showCounter(permission_function.permission, 'permission_function.permission')"
											:rules="ifValid('permission_function.permission')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
											v-model="permission_function.permission_token"
											:label="`${$t('lang.permission_token')} *`"
											:counter="showCounter(permission_function.permission_token, 'permission_function.permission_token')"
											:rules="ifValid('permission_function.permission_token')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
											v-model="permission_function.method"
											:label="`${$t('lang.method')} *`"
                                            :items="methods"
											item-value="value"
											item-text="text"
											:rules="ifValid('permission_function.method')"
                                        ></bc-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currFunctionField('function_id')" color="error" @mouseup.left="$refs.delete_function.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="permission_function_dialog = false">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyFunction(currFunctionField('function_id') ? 'patch' : 'post', currFunctionField('function_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_module"
                :message="`This will remove the module: ${currModuleField('module')}`"
                :heading="$t('lang.confirm_delete_header')"
                @onConfirm="modifyModule('delete', currModuleField('module_id'))"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_function"
                :message="`This will remove the permission function: ${currFunctionField('permission')}`"
                :heading="$t('lang.confirm_delete_header')"
                @onConfirm="modifyFunction('delete', currFunctionField('function_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from "Store/store";
import app from "Main";

export default {
    data() {
        return {
            current_module: null,
            current_function: null,
            permission_module: {
                module: "",
            },
            permission_function: {
                permission: "",
                permission_token: "",
                method: "",
            },
            methods: [
                { value: "get", text: this.$t("lang.get") },
                { value: "put", text: this.$t("lang.put") },
                { value: "patch", text: this.$t("lang.patch") },
                { value: "post", text: this.$t("lang.post") },
                { value: "delete", text: this.$t("lang.delete") },
            ],
            permission_module_dialog: false,
            permission_function_dialog: false,
            dbGetModules: _.debounce(this.getModules, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        if (store.getters.user_is_dev) {
            store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    stateProperty: "modules",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.modules) {
                        next((vm) => {
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            app.createAlert();
            next({ name: "dashboard", replace: true });
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (store.getters.user_is_dev) {
            this.$store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    stateProperty: "modules",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.modules) {
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            this.createAlert();
            next({ name: "dashboard", replace: true });
        }
    },
    computed: {
        ...mapState({
            rules_permission_module: (state) => state.modules.rules_permission_modules,
            rules_permission_function: (state) => state.modules.rules_permission_function,
            modules: (state) => state.modules.modules,
        }),
        currModuleField() {
            return (field) => {
                return this.current_module && field && this.current_module[field] ? this.current_module[field] : "";
            };
        },
        currFunctionField() {
            return (field) => {
                return this.current_function && field && this.current_function[field] ? this.current_function[field] : "";
            };
        },
    },
    methods: {
        closeModuleDialog() {
            this.permission_module_dialog = false;
            this.$refs.permission_module.reset();
            this.$refs.delete_module.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        closeFunctionDialog() {
            this.permission_function_dialog = false;
            this.$refs.permission_function.reset();
            this.$refs.delete_function.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getModules(status = true) {
            if (status) {
                this.startLoader();
            }
            this.$store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    stateProperty: "modules",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.modules) {
                    } else {
                        this.$router.push({ path: "/" });
                    }
                })
                .finally(() => {
                    this.finishLoader(true);
                    this.$store.commit("toggleModalLoader", false);
                    this.permission_module_dialog = false;
                    this.permission_function_dialog = false;
                });
        },
        modifyModule(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("permission_module")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchModules", {
                                pk: "module_id",
                                id: id,
                                url: `modules/${id ? id : ""}`,
                                method: method,
                                stateProperty: "modules",
                                dataProperty: method == "post" ? "module" : "modules",
                                mutate: true,
                                body: method != "delete" ? this.permission_module : null,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeModuleDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        modifyFunction(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("permission_function")) {
                        this.$store.commit("toggleModalLoader", true);
                        let module_index = this.modules.findIndex((obj) => obj.module_id == this.currModuleField("module_id"));
                        this.$store
                            .dispatch("fetchModules", {
                                pk: "function_id",
                                id: id,
                                url: `modules/${this.currModuleField("module_id")}/permissions/${id ? id : ""}`,
                                method: method,
                                stateProperty: `modules[${module_index}].permission_functions`,
                                dataProperty: "permissions",
                                mutate: true,
                                body: method != "delete" ? this.permission_function : null,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeFunctionDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showModule(item = null) {
            this.current_module = item;
            if (this.$refs.permission_module) item ? this.$refs.permission_module.resetValidation() : this.$refs.permission_module.reset();

            this.$nextTick(() => {
                this.assignObj(this.permission_module, item, this.rules_permission_module);
                this.permission_module_dialog = true;
            });
        },
        showPermission(module, item = null) {
            this.current_module = module;
            this.current_function = item;
            if (this.$refs.permission_function) item ? this.$refs.permission_function.resetValidation() : this.$refs.permission_function.reset();

            this.$nextTick(() => {
                this.assignObj(this.permission_function, item, this.rules_permission_function);
                this.permission_function_dialog = true;
            });
        },
    },
};
</script>
